import type { Path, PathValue } from 'viewup-lib/types';
import { type StoreApi, type UseBoundStore, useStore } from 'zustand';
import { getNestedValue } from './getNestedValue';

export const createSelector =
  <Props extends object, S extends UseBoundStore<StoreApi<Props>>>(store: S) =>
  () => {
    const getValue = <K extends Path<Props>>(key: K) => {
      return store((state) => getNestedValue(state, key)) as PathValue<Props, K>;
    };

    return {
      getValue,
    };
  };

export const createPureStoreSelector = <Props extends object, S extends StoreApi<Props>>(
  store: S,
) => {
  const getValue = <K extends Path<Props>>(key: K) => {
    return useStore(store, (state) => getNestedValue(state, key) as PathValue<Props, K>);
  };

  return { getValue };
};
